import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DownLoadFileService } from "app/services/download-file.service";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { MemberCorrespondenceType } from "~app/addresses/store/member-correspondence-type/member-correspondence-type.model";
import { ProfessionalDomicileAddress } from "~app/addresses/store/member-professional-domicile/member-professional-domicile.model";
import { MemberResidence } from "~app/addresses/store/member-residence/models/member-residence.model";
import { MemberSecondaryWorkAddress } from "~app/addresses/store/member-secondary-work-address/models/member-secondary-work-address.model";
import { environment } from "~env";
import {
  AnnualRegistrationForm,
  CheckPaymentDto,
  DynamicQuestion,
  MemberDocumentToAdd,
  PaymentReceipt,
  ProceedInscriptionPaymentDto
} from "./inscription.model";

@Injectable({
  providedIn: "root",
})
export class InscriptionCommandService {
  private COMMAND_API = environment.registrarCommandApi;
  private PAYMENT_API = environment.registrarPaymentApi;

  constructor(
    private http: HttpClient,
    private downLoadFileService: DownLoadFileService
  ) { }

  submitInscriptionForm(
    memberId: string,
    formData: AnnualRegistrationForm,
    year: string,
    questions: DynamicQuestion[],
    residence: MemberResidence,
    professionalDomicile: ProfessionalDomicileAddress,
    correspondenceType: MemberCorrespondenceType,
    workAddresses: MemberSecondaryWorkAddress[]
  ): Observable<any> {
    const url = `${this.COMMAND_API}/member/${memberId}/annual-registration`;
    const cleanFormData = this.cleanFormDataBeforeSent(formData);

    return this.http.post(url, {
      ...cleanFormData,
      year,
      questions,
      residence,
      professionalDomicile,
      correspondenceType,
      workAddresses
    });
  }

  private cleanFormDataBeforeSent(
    formData: AnnualRegistrationForm
  ): AnnualRegistrationForm {
    const newDatas = {
      workHours: [],
      answers: formData.answers,
      state: formData.state,
      paymentReceipt: formData.paymentReceipt,
      memberUnpaidBills: formData.memberUnpaidBills,
      workAddressesForUpdate: []
    };
    formData.workHours.forEach((wo) => {
      if (
        !!wo.clinicAddresse &&
        !!wo.asOf
      ) {
        newDatas.workHours.push(wo);
      }
    });


    formData.workAddressesForUpdate.forEach(wa => {
      let workAddressForUpdate = {
        clinic: wa.clinic,
        practiceType: wa.practiceType?.id,
        otherPracticeType: wa.otherPracticeType,
        practiceTypeAddress: wa.practiceTypeAddress.id,
        otherPracticeTypeAddress: wa.otherPracticeTypeAddress,
        professionalContext: wa.professionalContext.id,
        otherProfessionalContext: wa.otherProfessionalContext,
        municipalityCode: wa.municipalityCode,
        isWheelChairAccessible: wa.isWheelChairAccessible,
        isCompanyAddress: wa.isCompanyAddress,
        companyName: wa.companyName,
        isAssociate: wa.isAssociate,
        isSelfEmployed: wa.isSelfEmployed,
        isEmployee: wa.isEmployee,
        workAddressId: wa.id,
        practiceTypeDto: wa.practiceType,
        practiceTypeAddressDto: wa.practiceTypeAddress,
        professionalContextDto: wa.professionalContext
      };

      newDatas.workAddressesForUpdate.push(workAddressForUpdate);
    });

    return newDatas;
  }

  proceedInscriptionPayment(
    memberId: string,
    dto: ProceedInscriptionPaymentDto
  ): Observable<PaymentReceipt> {
    const url = `${this.PAYMENT_API}/payment/${memberId}/proceed-contribution-payment`;
    return this.http.post<PaymentReceipt>(url, dto);
  }

  proceedInscriptionChequePayment(
    memberId: string,
    dto: CheckPaymentDto
  ): Observable<PaymentReceipt> {
    const url = `${this.PAYMENT_API}/payment/${memberId}/proceed-contribution-payment-by-check`;
    return this.http.post<PaymentReceipt>(url, dto);
  }

  createMemberDocument(
    memberId: string,
    document: MemberDocumentToAdd
  ): Observable<string> {
    const URL = `${this.COMMAND_API}/member/${memberId}/document/add-registration-pdf`;

    const data = new FormData();

    data.append("note", document.note);
    data.append("origin", "Portail");
    data.append("documentTypeId", document.documentTypeId);

    if (!!document.file) {
      data.append("documentType", "MemberGenericDocument");
      data.append("document", document.file, document.file.name);
    }

    return this.http.post<string>(URL, data);
  }

  authorizeDocumentDownload(
    memberId: string,
    documentId: string,
    filename: string
  ): Observable<string> {
    const URL = `${this.COMMAND_API}/member/${memberId}/document/${documentId}/authorize-download-portal`;
    return this.http
      .post(URL, {})
      .pipe(
        switchMap((res: { location: string }) =>
          this.downLoadFileService.downloadFile(res.location, filename)
        )
      );
  }
}
